
import React, { useEffect, useState } from "react"
import { Card, CardBody, CardTitle, Container } from "reactstrap"
import { __ } from "../../app"
import VendorEditor from "../../components/vendor-editor"
import { updateVendor, useVendor } from "../../services/vendor-service"

import { useHistory } from 'react-router-dom'
import { Box, Button, CircularProgress, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Fragment } from "react"
import VendorBalancesDatatable from "../../components/vendor-balances-datatable"
import PageHeader from "../../components/page-header"
import VendorSiteBalancesDatatable from "../../components/vendor-site-balances-datatable"


export default function EditVendor( {
    match
} ) {
    const id = match?.params?.id;
    const [ vendorModel, setVendorModel, isVendorModelLoading ] = useVendor( id, { context: 'object' } )
    
    const history = useHistory();
    var historyState = history.location.state;
    
    const [ isLoading, setLoading ] = useState( false )
    const [ errors, setErrors ] = useState( [] )
    const [ alerts, setAlerts ] = useState( 
        historyState?.created ? [
            {
                severity: 'success',
                title: __( 'Vendor created successfully.' )
            }
        ] : 
        []
    )

    const [ currentTab, setCurrentTab ] = useState( "details" );

    useEffect( () => {
        console.log( 'Model Updated', vendorModel )
    }, [ vendorModel ] )


    async function onSaveVendorClicked() {

        if( isLoading ) return;
        setLoading( true );
        setErrors( [] );
        setAlerts( [] )

        var errors = validateVendor();
        if( errors.length ) {
            setErrors( errors );
            setAlerts( [] );
            setLoading( false );
            return;
        }

        var response = await updateVendor( vendorModel )
        setLoading( false )

        if( response?.error && response?.message ) {
            setErrors( [ response.message ] );
            setAlerts( [] );
            return;
        }

        if( !response?.data || !response?.data?.id ) {
            setErrors( [ 'An unknown error occured, check console for more details.' ] );
            setAlerts( [] );
            return;
        }

        setVendorModel( response.data );
        setErrors( [] );
        setAlerts( [
            {
                severity: 'success',
                title: __( 'Vendor saved successfully.' )
            }
        ] )
    }
    
    function validateVendor() {
        var errors = [];

        if( !vendorModel?.name ) {
            errors.push( "Name cannot be empty." )
        }

        if( !vendorModel?.email ) {
            errors.push( "Email cannot be empty." )
        }

        if( !vendorModel?.contactName ) {
            errors.push( "Contact name cannot be empty." )
        }

        if( !vendorModel?.companyName ) {
            errors.push( "Company name cannot be empty." );
        }

        if( !vendorModel?.phone ) {
            errors.push( "Phone cannot be empty." )
        }

        if( !vendorModel?.address?.city ) {
            errors.push( "Address city cannot be empty." )
        }

        if( !vendorModel?.address?.country ) {
            errors.push( "Address country cannot be empty." )
        }

        if( !vendorModel?.address?.line1 ) {
            errors.push( "Address Line 1 cannot be empty." )
        }

        if( !vendorModel?.address?.postCode ) {
            errors.push( "Address postcode cannot be empty." )
        }

        if( !vendorModel?.address?.state ) {
            errors.push( "Address state cannot be empty." )
        }

        return errors;
    }


    function ActionsComponent() {

        return (
            <Fragment>
                <Button 
                    variant="contained"
                    onClick={ () => onSaveVendorClicked() }
                    disabled={ isVendorModelLoading }
                >
                    { __( 'Save' ) }
                </Button>
                        
                { isLoading && (
                    <CircularProgress />
                ) }
            </Fragment>
        )
    }
    

    return (
        
        <div className="views_view views__edit-vendor">

            <PageHeader
                header={ 'Vendor: ' + ( vendorModel?.name || id ) }
                breadcrumbs={ [ 
                    { 
                        to: '/vendors',
                        label: __( 'Vendors' )
                    },
                    { 
                        to: '/vendors/id/' + id,
                        label: vendorModel?.name || id,
                        active: true
                    } 
                ] }
                alerts={ errors?.length > 0 ? [ 
                    ... alerts,
                    {
                        severity: 'error',
                        title: __( 'Error(s) while updating vendor.' ),
                        withList: errors
                    }
                ] : alerts }
            />  

            <TabContext value={ currentTab }>
                <Box>
                    <TabList onChange={ ( e, currentTab ) => setCurrentTab( currentTab ) }>
                        <Tab label={ __( 'Details' ) } value='details' />
                        <Tab label={ __( 'Site Balances' ) } value='site-balances' />
                        <Tab label={ __( 'Zone Balances' ) } value='balances' />
                    </TabList>
                </Box>

                <TabPanel value="details">
                        
                    <Card>
                        <CardBody>
                            <VendorEditor 
                                vendorModel={ vendorModel }
                                isVendorModelLoading={ isVendorModelLoading }
                                onVendorModelChanged={ vendorModel => {
                                    setVendorModel( vendorModel ) 
                                } }
                                ActionsComponent={ ActionsComponent }
                            />
                        </CardBody>
                    </Card>
                </TabPanel>
                                

                <TabPanel value="balances">
                    { vendorModel?.id > 0 && <VendorBalancesDatatable vendorId={ vendorModel.id } /> }
                </TabPanel>
                                

                <TabPanel value="site-balances">
                    { vendorModel?.id > 0 && <VendorSiteBalancesDatatable vendorId={ vendorModel.id } /> }
                </TabPanel>

            </TabContext>

        </div>
    )
}